let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hzK1f")).then(() => parcelRequire('9AnKp'));